module.exports = __webpack_public_path__ + "static/img/0000志愿者.0d24f57.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000志愿者.jpg
// module id = Jddi
// module chunks = 0